import { render, staticRenderFns } from "./noteBox.vue?vue&type=template&id=1a40e9c8&scoped=true&"
import script from "./noteBox.vue?vue&type=script&lang=js&"
export * from "./noteBox.vue?vue&type=script&lang=js&"
import style0 from "./noteBox.vue?vue&type=style&index=0&id=1a40e9c8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a40e9c8",
  null
  
)

export default component.exports